<script setup lang="ts">
defineProps<{
  confirmLabel: string;
}>();

const emit = defineEmits<{
  cancel: [];
  confirm: [];
}>();
</script>

<template>
  <div class="flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-end">
    <el-button
      class="!m-0 w-full px-6 sm:w-auto"
      @click="emit('cancel')"
    >
      {{ $t('COMMON.CANCEL') }}
    </el-button>
    <el-button
      type="danger"
      class="!m-0 w-full px-6 sm:w-auto"
      @click="emit('confirm')"
    >
      {{ confirmLabel }}
    </el-button>
  </div>
</template>
